import { ref, watch, computed } from '@vue/composition-api';
import { TABLE } from '@/constants/config';
import { pluck } from '@/helpers';

export default function usePendingNomineeDirectorsTable() {
    const refPendingNomineeDirectorListTable = ref(null);

    // Table Handlers
    const pendingNomineeDirectorTableColumns = [
        { key: 'index', label: '#', thClass: 'px-1 pr-2', tdClass: 'px-1 pr-2' },
        { key: 'nomineeDirector.name', label: 'NOMINEE DIRECTOR NAME', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'nominatorType.text', label: 'NOMINATOR TYPE', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'nominator.text', label: 'NOMINATOR NAME', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'appointmentDate', label: 'APPOINTMENT', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'cessationDate', label: 'CESSATION', sortable: true, thClass: 'px-0 pr-2', tdClass: 'px-0 pr-2' },
        { key: 'actions', label: 'ACTION', thClass: 'pl-0 pr-1 text-right', tdClass: 'px-0 pr-1 text-right' },
    ];

    const pendingNomineeDirectorPerPage = ref(TABLE.PER_PAGE);
    const totalPendingNomineeDirectors = ref(0);
    const pendingNomineeDirectorCurrentPage = ref(1);
    const pendingNomineeDirectorPerPageOptions = TABLE.PER_PAGE_OPTIONS;
    const pendingNomineeDirectorSearchQuery = ref('');
    const sortPendingNomineeDirectorBy = ref('id');
    const isSortDirDescPendingNomineeDirector = ref(true);
    const isPendingNomineeDirectorBusy = ref(false);

    // local variable to store the companies list
    const isLoadingPendingNomineeDirector = ref(false);

    // options where the search query is applied
    // make sure to list as keys of how to access those values in table 
    const filterOnPendingNomineeDirector = ref([
        'nomineeDirector.name',
    ]);

    const PendingNomineeDirectorDataMeta = computed(() => {
        const localItemsCount = refPendingNomineeDirectorListTable.value ? refPendingNomineeDirectorListTable.value.localItems.length : 0;
        totalPendingNomineeDirectors.value = localItemsCount;
        return {
            from: pendingNomineeDirectorPerPage.value * (pendingNomineeDirectorCurrentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: pendingNomineeDirectorPerPage.value * (pendingNomineeDirectorCurrentPage.value - 1) + localItemsCount,
            of: totalPendingNomineeDirectors.value,
        };
    });

    // const getShareholderType = type => {
    //     // director.shareholder_type.includes('Individual') ? NOMINEE_DIRECTOR.NOMINATOR.TYPE.INDIVIDUAL : NOMINEE_DIRECTOR.NOMINATOR.TYPE.CORPORATE,
    //     if(type.toLowerCase().includes(SHAREHOLDER.TYPE.INDIVIDUAL))
    //         return { 
    //             text: SHAREHOLDER.TYPE.INDIVIDUAL,
    //             value: SHAREHOLDER.TYPE.INDIVIDUAL
    //         };
            
    //     return { 
    //         text: SHAREHOLDER.TYPE.CORPORATE,
    //         value: SHAREHOLDER.TYPE.CORPORATE
    //     };
    // };
   
    // to change api data to straightforward easy, js, local data
    // const localizePendingNomineeDirectorData = data => ({
    //     _id: generateRandomUniqueId(),
    //     id: data.id,
    //     userId: data.user_id,
    //     requestType: data.request_type,
    //     nomineeDirector: {
    //         id: data.user_id,
    //         name: data.user?.name
    //     },
    //     nominator: data.shareholder ? {
    //         value: data.shareholder.user.id,
    //         text: data.shareholder.user?.user_info?.legal_name ?? data.shareholder.user.name
    //     } : null,
    //     alias: data.shareholder?.alias,
    //     nominatorType: data.shareholder_type ? getShareholderType(data.shareholder_type) : null,
    //     appointmentDate: formatDate(data.appointment_date),
    //     cessationDate: formatDate(data.cessation_date),
    //     remark: data.remarks,
    //     uen: data.shareholder?.uen,
    //     statue: data.shareholder?.statue,
    //     registrar: data.shareholder?.registrar,
    //     jurisdiction: data.shareholder?.jurisdiction,
    //     legalForm:  data.shareholder?.legal_form ? {
    //         value: data.shareholder.legal_form,
    //         text: data.shareholder.legal_form
    //     } : null,
    // });

    // const fetchPendingNomineeDirectors = () => {
    //     isLoadingPendingNomineeDirector.value = true;

    //     GenerateDocument
    //         .getPendingNomineeDirectors()
    //         .then(response => {
    //             localPendingNomineeDirectors.value = response.map(director => localizePendingNomineeDirectorData(director));
                
    //             pendingNomineeDirectors.value = localPendingNomineeDirectors.value;

    //             isLoadingPendingNomineeDirector.value = false;
    //         })
    //         .catch(e => {
    //             console.error("Error fetching pending pendingNomineeDirectors", e);

    //             toast({
    //                 component: ToastificationContent,
    //                 props: {
    //                     title: 'Error fetching pending director list',
    //                     icon: 'AlertTriangleIcon',
    //                     variant: 'danger',
    //                 },
    //             });
    //         });
    // };

    // fetchPendingNomineeDirectors();

    const refetchPendingNomineeDirectorData = () => {
        refPendingNomineeDirectorListTable.value.refresh();
    };

    watch([pendingNomineeDirectorCurrentPage, pendingNomineeDirectorPerPage, pendingNomineeDirectorSearchQuery], () => {
        refetchPendingNomineeDirectorData();
        
        let data = refPendingNomineeDirectorListTable.value.localItems;
        const queryLowered = pendingNomineeDirectorSearchQuery.value.toLowerCase().trim();

        //  if a query present then search
        if (queryLowered)
        {
            data = refPendingNomineeDirectorListTable.value.localItems.filter(item => filterOnPendingNomineeDirector.value.some(key => {
                const value = pluck(key, item);
                return value && value.toString().toLowerCase().trim().includes(queryLowered);
            }));
        }

        refPendingNomineeDirectorListTable.value.localItems = data;
        isPendingNomineeDirectorBusy.value = false;
    });

    return {
        sortPendingNomineeDirectorBy,
        isPendingNomineeDirectorBusy,
        pendingNomineeDirectorPerPage,
        PendingNomineeDirectorDataMeta,
        isLoadingPendingNomineeDirector,
        pendingNomineeDirectorSearchQuery,
        pendingNomineeDirectorCurrentPage,
        pendingNomineeDirectorTableColumns,
        isSortDirDescPendingNomineeDirector,
        totalPendingNomineeDirectors,
        pendingNomineeDirectorPerPageOptions,
        refPendingNomineeDirectorListTable,

        refetchPendingNomineeDirectorData,
        filterOnPendingNomineeDirector,
    };
}
